import { PosPrintDocumentsModalService } from './../../../../@core/services/pos-print-documents-modal.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ColumnTable } from 'src/app/models/column-table';
import { Filter } from 'src/app/models/filter';
import { RecollectionFilter } from 'src/app/models/filters/recollection-filter';
import { Paging } from 'src/app/models/page';
import { Recollection } from 'src/app/models/recollection';
import { CustomerService } from 'src/app/services/customer.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { LoanService } from 'src/app/services/loan.service';

@Component({
  selector: 'app-customer-recollection-list',
  templateUrl: './customer-recollection-list.component.html',
  styleUrls: ['./customer-recollection-list.component.sass'],
})
export class CustomerRecollectionListComponent implements OnInit {
  @Input('customerCode') set customer(customerCode: string) {
    if (customerCode != null && customerCode != '') {
      this.customerCode = customerCode;
      this.loanService
        .getRecollectionListByFilter({
          page: 0,
          pageSize: 10,
          value: { customerCode, status: 'OK' },
        })
        .toPromise()
        .then((recollectionListResponse) => {
          recollectionListResponse.response.content
            .filter((r) => r.invoiceCode != null)
            .forEach(async (r: Recollection) => {
              r.invoice = (
                await this.invoiceService
                  .readInvoices({
                    page: 0,
                    pageSize: 100,
                    value: { code: r.invoiceCode },
                  })
                  .toPromise()
              ).response.content[0];
            });
          this.recollectionList = recollectionListResponse.response;
          this.amountOfRecollections.emit(
            this.recollectionList.numberOfElements
          );
        });
    }
  }

  @Output() amountOfRecollections: EventEmitter<number> =
    new EventEmitter<number>();

  recollectionList: Paging<Array<Recollection>> = new Paging([]);
  customerCode: string = '';

  constructor(
    private loanService: LoanService,
    private invoiceService: InvoiceService,
    private posPrintDocumentsModalService: PosPrintDocumentsModalService,
    private customerService: CustomerService
  ) {}

  ngOnInit(): void {}

  getRecollectionHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable('customerCode', 'Codigo'),
      new ColumnTable('status', 'Estado', { type: 'badge' }),
      new ColumnTable('createdBy', 'Creado Por'),
      new ColumnTable('createdOn', 'Fecha Creacion'),
      new ColumnTable('recollectionResponse.message', 'Mensaje'),
      new ColumnTable('receipt.code', 'Recibo'),
      new ColumnTable('invoice.fullNumber', 'Factura'),
      new ColumnTable('recollectionType', 'Tipo de Recaudo', {
        type: 'badge',
        valueMap: new Map<string, string>()
          .set('QUOTAS', 'Pago de Cuotas')
          .set('PAYOFF', 'Abono a Capital')
          .set('CONDONATION', 'Condonacion')
          .set('REPAIRSHOP', 'Factura de Taller')
          .set('OTHERS', 'Otros Cobros'),
      }),
      new ColumnTable('code', '', {
        type: 'action',
        isIcon: true,
        iconClass: 'fa fa-print',
        actions: [
          {
            fn: async (recollection: Recollection) => {
              const customer = await this.customerService
                .readCustomerByCode(this.customerCode)
                .toPromise();
              this.posPrintDocumentsModalService.showPrintRecollectionDocuments(
                recollection,
                {
                  fullNumber: recollection.invoice?.fullNumber || '',
                  netTotal: recollection.invoice?.totals.netTotal || 0,
                  code: recollection.invoiceCode,
                  salesOrg: recollection.invoice?.salesOrg || '',
                },
                customer
              );
            },
            icon: 'fa fa-print',
            tooltip: 'Imprimir Documentos',
            isDisabled: false,
          },
        ],
      }),
    ];
  }

  async getRecollections(filter: Filter<RecollectionFilter>): Promise<void> {
    filter = {
      ...filter,
      value: { status: 'OK', customerCode: this.customerCode },
    };
    this.recollectionList = (
      await this.loanService.getRecollectionListByFilter(filter).toPromise()
    ).response;
  }
}
